import { useContext } from 'react';
import { AppContext } from '@edx/frontend-platform/react';
import { changeUserLanguage, siteLanguageList, isValidLanguage } from '../api/Language';

export function useLanguage() {
  const { authenticatedUser, locale } = useContext(AppContext);

  const handleLanguageChange = async (selectedLanguage) => {
    try {
      if (!isValidLanguage(selectedLanguage)) {
        throw new Error('Invalid language code');
      }

      if (authenticatedUser && authenticatedUser.username) {
        await changeUserLanguage(authenticatedUser.username, selectedLanguage);
        // Reload the page to apply the language change
        window.location.reload();
      } else {
        console.error('User not authenticated');
        throw new Error('User not authenticated');
      }
    } catch (error) {
      console.error('Error changing language:', error);
      throw error;
    }
  };

  return {
    availableLanguages: siteLanguageList,
    changeLanguage: handleLanguageChange,
    locale
  };
} 